import * as React from 'react'

import { computed, makeObservable, observable, runInAction } from 'mobx'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import QrCodesStore from '../../../QRCodes.store'
import { QRCodesViewFormStore } from '../QRCodesViewForm.store'

interface IProps {
  store: QRCodesViewFormStore
  qrCodesStore: QrCodesStore
}

enum Steps {
  START_QUEUE = 'START_QUEUE',
  START_SESSION = 'START_SESSION',
  END_SESSION = 'END_SESSION',
}

@observer
export default class QueueFooter extends React.Component<IProps> {
  @observable private localProps: IProps = null

  public constructor(props: IProps) {
    super(props)
    this.localProps = props
    makeObservable(this)
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps !== this.props) {
      runInAction(() => {
        this.localProps = this.props
      })
    }
  }

  public render(): JSX.Element {
    const {
      qrCodesStore: {
        toggleEndRideConfirm,
        toggleStartSessionShown,
        startQueue,
      },
      store: { userBusEnterMap },
    } = this.props

    const areUsersOnBus = Object.values(userBusEnterMap).length > 0

    return (
      <>
        {this.currentStep === Steps.START_QUEUE && (
          <Button
            variant="primary-outline"
            className="medium-bold tw:grow"
            onClick={startQueue}
          >
            {Localization.translator.startQueue}
          </Button>
        )}
        {this.currentStep === Steps.START_SESSION && (
          <Button
            variant="primary-outline"
            className="medium-bold tw:grow"
            onClick={toggleStartSessionShown}
            disabled={!areUsersOnBus}
          >
            {Localization.translator.startSession}
          </Button>
        )}
        {this.currentStep === Steps.END_SESSION && (
          <Button
            variant="default"
            className="medium-bold tw:grow"
            onClick={toggleEndRideConfirm}
          >
            {Localization.translator.endSessionForAll}
          </Button>
        )}
      </>
    )
  }

  @computed
  private get currentStep(): Steps {
    const {
      qrCodesStore: { isActive, isQueueActive },
    } = this.localProps

    if (!isActive) return Steps.START_QUEUE
    if (isQueueActive) return Steps.START_SESSION
    return Steps.END_SESSION
  }
}
